type OptionType = {
  label: string;
  value: string;
};
export const SHIPPING_SPEED_OPTIONS: OptionType[] = [
  {
    label: 'Expedited',
    value: 'EXPEDITED',
  },
  {
    label: 'Standard',
    value: 'STANDARD',
  },
  {
    label: 'Local Delivery',
    value: 'LOCAL_DELIVERY',
  },
];

export const SHIPPING_METHOD_OPTIONS: OptionType[] = [
  {
    label: 'Cargo',
    value: 'CARGO',
  },
  {
    label: 'Freight',
    value: 'FREIGHT',
  },
];
export const SHIPPING_RATE_METRICS: OptionType[] = [
  {
    label: 'KG',
    value: 'KG',
  },
  {
    label: 'Volume',
    value: 'VOLUME',
  },
];
export const SHIPPING_MEASUREMENT_RANGE_KG: OptionType[] = [
  { label: '0-10', value: 'RANGE_1' },
  { label: '11-20', value: 'RANGE_2' },
  { label: '21-50', value: 'RANGE_3' },
  { label: '51-100', value: 'RANGE_4' },
];
export const SHIPPING_MEASUREMENT_RANGE_VOLUME: OptionType[] = [
  { label: 'option 1', value: 'OPTION_1' },
  { label: 'option 2', value: 'OPTION_2' },
  { label: 'option 3', value: 'OPTION_3' },
];
export const SHIPPING_MEASUREMENT_RANGE_MAPPING: Record<string, string> = {
  RANGE_1: '0-10',
  RANGE_2: '11-20',
  RANGE_3: '21-50',
  RANGE_4: '51-100',
  OPTION_1: 'option 1',
  OPTION_2: 'option 2',
  OPTION_3: 'option 3',
};

export const SHIPPING_RATE_METRICS_MAPPING: Record<string, string> = {
  KG: 'KG',
  VOLUME: 'Volume',
};
